import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Input, Output } from '@angular/core';
import { SideNaveActionsTypes, SideNaveData } from '@klickdata/core/mobile';
import { SideNaveResponseData } from '@klickdata/core/mobile/src/mobile.service';
import { QuoteTypes } from '@klickdata/core/quote';

@Component({
    selector: 'app-menu-side-add-quote',
    templateUrl: './menu-side-add-quote.component.html',
    styleUrls: ['./menu-side-add-quote.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideAddQuoteComponent implements OnInit {
    @Input() public navData: SideNaveData;
    @Output() onClose: EventEmitter<SideNaveResponseData> = new EventEmitter();
    SideNaveActionsTypes = SideNaveActionsTypes;
    QuoteTypes = QuoteTypes;

    constructor() {}

    ngOnInit(): void {}
}
